import React, { Component } from "react";
import * as Constant from "../../constant/general";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from "reactstrap";
import sha256 from "sha256";
import Loadable from "react-loading-overlay";
import { FormInputError } from "../../components/FormInputError";

class Login extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      email: "",
      password: "",
      emailErrMsg: "",
      passwordErrMsg: "",
      errorMsg: "",
    };

    this.loginHandler = this.loginHandler.bind(this);
    this.keyPress = this.keyPress.bind(this);
  }

  verifyForm() {
    this.setState({
      emailErrMsg: "",
      passwordErrMsg: "",
      errorMsg: "",
    });

    if (!this.state.email && !this.state.password) {
      this.setState({
        emailErrMsg: "Email cannot be empty",
        passwordErrMsg: "Password cannot be empty",
      });
    }

    if (!this.state.email) {
      this.setState({
        emailErrMsg: "Email cannot be empty",
      });

      return false;
    }

    if (!this.state.password) {
      this.setState({
        passwordErrMsg: "Password cannot be empty",
      });

      return false;
    }
    if (this.state.password.length < 8) {
      this.setState({
        passwordErrMsg: "Minimum password length is 8",
      });
      return false;
    }
    if (this.state.password.length > 20) {
      this.setState({
        passwordErrMsg: "Maximum password length is 20",
      });
      return false;
    }
    let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
    if (!regex.test(this.state.password)) {
      this.setState({
        passwordErrMsg:
          "The combination password must be at least 1 lowercase, 1 uppercase, 1 number & minimum 8 length characters",
      });
      return false;
    }

    return true;
  }

  loginHandler() {
    if (this.verifyForm()) {
      this.props
        .loginAction(this.state.email, sha256(this.state.password))
        .then(() => {
          if (this.props.payload.status && this.props.payload.result.useOtp) {
            this.props.history.push(Constant.Verification);
          } else if (
            this.props.payload.status &&
            !this.props.payload.result.useOtp
          ) {
            this.props.history.push(Constant.Search);
          } else {
            this.setState({
              errorMsg: this.props.payload.error.message,
            });
          }
        });
    }
  }

  keyPress(event) {
    if (event.key === "Enter") {
      this.loginHandler();
    }
  }
  handleClick (e)  {    
    let uriOri = window.location.protocol + "//" + window.location.host;
    let currentUrl = encodeURIComponent(uriOri);
    e.preventDefault();
    window.location.href = `${process.env.SSO_URL}/login/?redirect=${currentUrl}&salt=${process.env.SSO_APP_SALT}`;
  };
  render() {
    return (
      <Loadable active={this.props.payload.loading} spinner text="Loading...">
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="6" sm="12">
                <Card className="p-4">
                  <CardBody>
                    <Form className="text-center">
                      <h2>Welcome to MHC Hub</h2>
                      <p className="text-muted">
                        Version {process.env.REACT_APP_VERSION || "1.0.6"}
                      </p>
                      <p className="text-muted">Sign In to your account</p>

                      <Row>
                        <Col xs="12">
                          <Button
                            onClick={this.handleClick}
                            color="primary"
                            size="large"
                          >
                            Login with SSO
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Loadable>
    );
  }
}

export default Login;
